import { ApiService } from 'services';
import { toastr } from 'react-redux-toastr';

import { handleException } from 'actions/exceptions';

export const EDIT_ACCOUNT_TYPE = 'EDIT_ACCOUNT_TYPE';
export const EDIT_ACCOUNT_TYPE_CANCEL = 'EDIT_ACCOUNT_TYPE_CANCEL';
export const UPDATE_ACCOUNT_TYPE_REQUEST = 'UPDATE_ACCOUNT_TYPE_REQUEST';
export const UPDATE_ACCOUNT_TYPE_SUCCESS = 'UPDATE_ACCOUNT_TYPE_SUCCESS';
export const UPDATE_ACCOUNT_TYPE_ERROR = 'UPDATE_ACCOUNT_TYPE_ERROR';

function edit() {
  return {
    type: EDIT_ACCOUNT_TYPE
  };
}

function cancelEdit() {
  return {
    type: EDIT_ACCOUNT_TYPE_CANCEL
  };
}

function request() {
  return {
    type: UPDATE_ACCOUNT_TYPE_REQUEST
  };
}

function receive(accountType) {
  return {
    type: UPDATE_ACCOUNT_TYPE_SUCCESS,
    accountType
  };
}

function reject() {
  return {
    type: UPDATE_ACCOUNT_TYPE_ERROR
  };
}

export function editAccountType() {
  return (dispatch) => {
    dispatch(edit());
  };
}

export function cancelEditAccountType() {
  return (dispatch) => {
    dispatch(cancelEdit());
  };
}

export function updateAccountType(accountId, accountType) {
  const formData = new FormData();
  formData.append('accountType', accountType);

  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .updateAccountType(accountId, formData)
      .then(() => {
        dispatch(receive((accountType === null || accountType === undefined) ? null : Number(accountType)));
        toastr.success('Success', 'Account type updated successfully');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
